/* Gymatics cart page (/cart) R2 behaviour: hero chip + continue link, order note copy and
   Saving/Saved state, assurance tiles. Styles: assets/gymatics-premium-cart-page.css. */
(function () {
  if (window.__gmCartPage) return;
  window.__gmCartPage = true;

  function svg(path) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + path + '</svg>';
  }

  function itemCount() {
    var inputs = document.querySelectorAll('#main-cart-items .quantity__input');
    var n = 0;
    for (var i = 0; i < inputs.length; i++) n += parseInt(inputs[i].value, 10) || 0;
    return n;
  }

  function hero() {
    var head = document.querySelector('.cart-wrapper-header');
    var title = head && head.querySelector('.cart-wrapper__title');
    if (!head || !title) return;
    if (!head.querySelector('.gcp-hero__main')) {
      var main = document.createElement('div');
      main.className = 'gcp-hero__main';
      main.innerHTML = '<span class="gcp-eyebrow">Gymatics checkout</span>';
      head.insertBefore(main, title);
      main.appendChild(title);
      head.insertAdjacentHTML('beforeend',
        '<a class="gcp-back" href="/collections/all">' + svg('<path d="M19 12H5m6-6-6 6 6 6"/>') + 'Continue shopping</a>');
    }
    var chip = title.querySelector('.gcp-chip');
    var n = itemCount();
    if (!n) { if (chip) chip.remove(); return; }
    if (!chip) {
      chip = document.createElement('span');
      chip.className = 'gcp-chip';
      title.appendChild(chip);
    }
    var label = n + (n === 1 ? ' item' : ' items');
    if (chip.textContent !== label) chip.textContent = label;
  }

  var ASSURE =
    '<ul class="gc-assure" aria-label="Shopping with Gymatics">' +
    '<li class="gc-assure__item"><span class="gc-assure__icon">' + svg('<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>') + '</span>Secure checkout</li>' +
    '<li class="gc-assure__item"><span class="gc-assure__icon">' + svg('<path d="M12 21s-7-4.4-9.3-9A5 5 0 0 1 12 6a5 5 0 0 1 9.3 6c-2.3 4.6-9.3 9-9.3 9Z"/>') + '</span>Made in Wales</li>' +
    '<li class="gc-assure__item"><span class="gc-assure__icon">' + svg('<path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>') + '</span>Free local collection</li>' +
    '</ul>';

  function assure() {
    var blocks = document.querySelector('.cart__blocks');
    if (!blocks || blocks.querySelector('.gc-assure')) return;
    var anchor = blocks.querySelector('.cart__dynamic-checkout-buttons') || blocks.querySelector('.cart__ctas');
    if (anchor) anchor.insertAdjacentHTML('afterend', ASSURE);
  }

  function note() {
    var wrap = document.querySelector('.cart__blocks .cart__note');
    var area = document.getElementById('Cart-note');
    if (!wrap || !area || wrap.__gcp) return;
    wrap.__gcp = true;
    var label = wrap.querySelector('label');
    if (label) label.innerHTML = '<span class="gcp-note__text"><span>Add an order note</span><small>Gift message or delivery notes</small></span>';
    area.setAttribute('placeholder', 'e.g. It’s a gift, please don’t include the receipt. Or: leave with a neighbour if we’re out.');
    wrap.insertAdjacentHTML('beforeend', '<div class="gcp-note__status" aria-live="polite"><span class="gcp-note__state"></span><span class="gcp-note__count"></span></div>');
    var state = wrap.querySelector('.gcp-note__state');
    var count = wrap.querySelector('.gcp-note__count');
    var timer;
    function refresh() { count.textContent = area.value.trim() ? area.value.length + ' characters' : ''; }
    area.addEventListener('input', function () {
      refresh();
      state.textContent = 'Saving…';
      state.className = 'gcp-note__state is-on';
      clearTimeout(timer);
      timer = setTimeout(function () {
        state.textContent = 'Saved';
        state.className = 'gcp-note__state is-on is-saved';
        timer = setTimeout(function () { state.className = 'gcp-note__state is-saved'; }, 2200);
      }, 900);
    });
    refresh();
  }

  function run() { hero(); assure(); note(); }

  function init() {
    if (!document.getElementById('main-cart-items')) return;
    run();
    // quantities and totals are re-rendered by the theme after each change
    var main = document.getElementById('MainContent');
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
